import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Games from "@/pages/Games";
import Booking from "@/pages/Booking";
import Confirmation from "@/pages/Confirmation";
import Leaderboard from "@/pages/Leaderboard";
import Challenge from "@/pages/Challenge";
import ChallengeAccept from "@/pages/ChallengeAccept";
import AuthCallback from "@/pages/AuthCallback";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import GamesAdmin from "@/pages/admin/GamesAdmin";
import LocationsAdmin from "@/pages/admin/LocationsAdmin";
import SlotsAdmin from "@/pages/admin/SlotsAdmin";
import BookingsAdmin from "@/pages/admin/BookingsAdmin";
import LeaderboardAdmin from "@/pages/admin/LeaderboardAdmin";
import MarketingAdmin from "@/pages/admin/MarketingAdmin";
import ChallengesAdmin from "@/pages/admin/ChallengesAdmin";
import ReportsAdmin from "@/pages/admin/ReportsAdmin";
import ContentAdmin from "@/pages/admin/ContentAdmin";
import HolidaysAdmin from "@/pages/admin/HolidaysAdmin";
import AdminsAdmin from "@/pages/admin/AdminsAdmin";

function PublicShell({ children }) {
  return (
    <>
      <Navbar />
      <div className="min-h-screen">{children}</div>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<PublicShell><Landing /></PublicShell>} />
      <Route path="/games" element={<PublicShell><Games /></PublicShell>} />
      <Route path="/book/:gameId" element={<PublicShell><Booking /></PublicShell>} />
      <Route path="/booking/:ref" element={<PublicShell><Confirmation /></PublicShell>} />
      <Route path="/leaderboard" element={<PublicShell><Leaderboard /></PublicShell>} />
      <Route path="/challenge" element={<PublicShell><Challenge /></PublicShell>} />
      <Route path="/challenge/:code" element={<PublicShell><ChallengeAccept /></PublicShell>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="content" element={<ContentAdmin />} />
        <Route path="games" element={<GamesAdmin />} />
        <Route path="locations" element={<LocationsAdmin />} />
        <Route path="slots" element={<SlotsAdmin />} />
        <Route path="holidays" element={<HolidaysAdmin />} />
        <Route path="bookings" element={<BookingsAdmin />} />
        <Route path="leaderboard" element={<LeaderboardAdmin />} />
        <Route path="marketing" element={<MarketingAdmin />} />
        <Route path="challenges" element={<ChallengesAdmin />} />
        <Route path="reports" element={<ReportsAdmin />} />
        <Route path="admins" element={<AdminsAdmin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
